<template>
    <div>
        <div>
            <vs-row v-if="!embedded_mode" class="mb-2">
                <vs-col class="pl-0 pr-1" vs-xs="12" vs-sm="10" vs-lg="10">
                    <vs-input
                        v-model="filters.search"
                        placeholder="Type to search"
                        class="w-full"
                    />
                </vs-col>
                <vs-col class="pl-1 pr-0" vs-xs="12" vs-sm="2" vs-lg="2">
                    <router-link :to="{name: 'portfolio-new'}">
                        <vs-button
                            class="w-full"
                            color="primary"
                            type="filled"
                        >
                            Add New
                        </vs-button>
                    </router-link>
                </vs-col>
            </vs-row>
            <vs-row v-if="!embedded_mode" class="mb-base">
                <vs-col vs-xs="12" vs-sm="4" vs-lg="3" class="pl-0 pr-1">
                    <SelectForeign
                        :model.sync="filters.entity"
                        label="Filter by Entity"
                        placeholder="Type to Search"
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        label_class="mb-0"
                        input_class="mt-0 bg-white"
                        :show_id_in_label="true"
                        :endpoint="$store.state.apiendpoints.entity_list"
                        :use_id_as_value="true"
                        list_length="10000"
                    />
                </vs-col>
            </vs-row>
            <vs-table :data="results">
                <vs-tr>
                    <vs-th>ID</vs-th>
                    <vs-th>Name</vs-th>
                    <vs-th>Entity</vs-th>
                    <vs-th class="text-right"></vs-th>
                </vs-tr>
                <vs-tr v-for="(item, index) in results" :key="index">
                    <vs-td>{{ item.id }}</vs-td>
                    <vs-td>{{ item.name }}</vs-td>
                    <vs-td>{{ item.entity.name }}</vs-td>
                    <vs-td class="text-right">
                        <router-link :to="{name: 'portfolio-edit', params: {portfolio_id: item.id}}">
                            <vs-button 
                                class="ml-3" 
                                color="primary" 
                                type="filled" 
                                size="small"
                            >Edit</vs-button>
                        </router-link>
                        <vs-button 
                            class="ml-3" 
                            color="danger" 
                            type="filled" 
                            @click="doDelete(item, index)"
                            size="small"
                        >Delete</vs-button>
                    </vs-td>
                </vs-tr>
            </vs-table>
        </div>
        <vs-row v-if="total_items" class="mt-3">
            <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
        </vs-row>
    </div>
</template>

<script>
import { Request } from '../../utils/requests'
export default {
    props: {
        embedded_mode: {
            default: false
        },
        embedded_filters: {
            default: null
        }
    },
    data() {
        let offset = parseInt(this.$route.query.offset || 0)
        let limit = parseInt(this.$route.query.limit || 20)
        
        let current_page = Math.ceil((offset+limit)/limit)

        return  {

            results: [],

            next_url: null,
            loading: false,
            total_items: null,
            current_page: current_page,
            filters: {
                ordering: this.$route.query.ordering || [],
                search: this.$route.query.search || null,
                offset: offset,
                limit: limit,

                entity: this.$route.query.entity || null,
            }
        }
    },
    computed: {
        total_pages() {
            if(this.total_items == 0 || this.filters.limit == 0)  return 1
            return Math.ceil(this.total_items/this.filters.limit)
        }
    },
    mounted() {
        this.timer = null
        this.init()
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                if(this.current_page == null) return

                if(this.timer) clearTimeout(this.timer)

                this.timer = setTimeout(() => {       
                    console.log(newV)             
                    this.$router.push({name: this.$route.name, query: newV})
                }, 800)
            }
        },
        '$route.query'(newV) {
            this.load_data(newV)
        },
        current_page(newV, oldV) {
            if(newV == oldV) return
            this.filters.offset = (newV-1) * this.filters.limit
        }
    },
    methods: {
        init() {
            this.load_data(this.filters)
        },
        calculate_page() {
            if(this.filters.offset == 0)
                this.current_page = 1
            else
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit)
        },
        load_data(filters=null, next=false) {
            
            if(next && !this.next_url && !filters) return
            let url = (next && !filters) ? this.next_url : this.$store.state.apiendpoints.portfolio_list
            
            let payload = null
            if(filters)
                payload = this.deepclone(filters)
            else
                payload = {}

            if('ordering' in payload)
                if(Array.isArray(payload.ordering))
                    payload.ordering = payload.ordering.join(",") 
            
            if(this.embedded_mode && this.embedded_filters){
                payload = {...payload, ...this.embedded_filters}
            }

            this.loading = true
            this.$vs.loading()

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.results = res.results
                    this.total_items = res.count
                    this.next_url = res.next
                    this.loading = false
                    this.$vs.loading.close()
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    if(!next)
                        this.$router.push("/");
                    this.loading = false
                    this.$vs.loading.close()
                }
            )
        },
        doDelete(item, index) {
             this.$vs.dialog({
                type:'confirm',
                color: 'danger',
                title: `Are you sure?`,
                text: 'This will delete any data related to this item including sales, bookings, purchases, primary items, etc. This action cannot be undone.',
                accept: () => this._doDelete(item, index)
            })
        },
        _doDelete(item, index) {
            let url = this.$store.state.apiendpoints.portfolio + item.id + "/"

            item.submit_disabled = true

            Request(this, 'DELETE', url).then( 
                (res) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Deleted',
                        text: 'Deleted Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    item.submit_disabled = false
                    this.results.splice(index, 1)
                },
                (err) => {
                    
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    item.submit_disabled = false
                }
            )
        }
    }
}
</script>